import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DataexchangeService {

  private _orders: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  orders: Observable<Array<any>> = this._orders.asObservable();

  private _tabs: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  tabs: Observable<Array<any>> = this._tabs.asObservable();

  private _swapHistory: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  swapHistory: Observable<Array<any>> = this._swapHistory.asObservable();

  private _trades: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  trades: Observable<Array<any>> = this._trades.asObservable();

  private _selectedOnBehalfUser: BehaviorSubject<any> = new BehaviorSubject(null);
  selectedOnBehalfUser: Observable<any> = this._selectedOnBehalfUser.asObservable();

  private _changeLanguage: BehaviorSubject<string> = new BehaviorSubject('');
  $changeLanguage: Observable<string> = this._changeLanguage.asObservable();

  constructor() {
  }

  setOrders(value: Array<any>) {
    this._orders.next(value);
  }

  setSwapHistory(swapHistory: Array<any>) {
    this._swapHistory.next(swapHistory);
  }

  setTabs(tabs: Array<any>) {
    this._tabs.next(tabs);
  }

  setTrades(trades: Array<any>) {
    this._trades.next(trades);
  }

  setSelectedOnBehalfUser(value: string) {
    this._selectedOnBehalfUser.next(value);
  }

  changeLanguage(value: string) {
    this._changeLanguage.next(value);
  }

  resetObservablesToDefaultValue() {
    this.setOrders([]);
    this.setSwapHistory([]);
    this.setTrades([]);
    this.setSelectedOnBehalfUser(null);
    this.changeLanguage('');
  }
}
